module.exports = __webpack_public_path__ + "img/grey_031.719ca230.png";